<template>  
  <div class="resPassword">
      <span class="resPassword-span"></span> 
      <div class="resPassword-div" >
        <div class="resPassword-div1" v-if="tORf">
          <h1> <span>MD</span> COLLEGE</h1>
          <input type="text" placeholder="新密码 / New Password">
          <input type="text" placeholder="重复密码 / Repeat Password">
          <button @click="handleClick">确认修改</button>
        </div>
        <div class="resPassword-div1" v-if="!tORf">
          <h1> <span>MD</span> COLLEGE</h1>
          <p>Reset</p>
          <p>Successfully</p>
          <button>前往登录</button>
        </div>
        
      </div>
      
  </div>
</template>

<script>
export default {
  name: 'resPassword',
  data () {
    return {
        tORf:true,
    }
  },
  methods:{
    handleClick(){
        this.tORf = !this.tORf;
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .resPassword{
      background-color: #000;
      height:650px;
      position: relative;
      background-image: url(https://static.wixstatic.com/media/a36401_daf7afb57f9c4561abef96257d85b524~mv2_d_3500_3500_s_4_2.jpg/v1/fill/w_1920,h_1920,al_c,q_85,usm_0.66_1.00_0.01/a36401_daf7afb57f9c4561abef96257d85b524~mv2_d_3500_3500_s_4_2.webp);
      background-size: 650px auto;
      background-repeat: no-repeat;
      background-position-x:50%; 

  }
  .resPassword-span{
      position: absolute;
      top:0;
      left: 0;
      height: 650px;
      width: 100%;
      background-color: #000;
      opacity: 0.5;
  }
  .resPassword-div{
      position: absolute;
      left: 50%;
      margin-left: -490px;
      width: 980px;
      height: 100%;
      color:#fff;
  }
  .resPassword-div1{
      width: 240px;
      background-color: rgba(50, 50, 50, 1);
      border-radius: 20px;
      text-align: center;
      padding-top: 30px;
      padding-left: 30px;
      padding-right: 30px;
      padding-bottom: 50px;
      position: absolute;
      left: 50%;
      margin-left: -150px;
      top:165px;
  }
  .resPassword-div1 h1{
      font-size: 19px;
      font-weight: 500;
      margin-bottom: 30px;
  }
  .resPassword-div1 h1 span{
    font-family: braggadocio;
    color: #FF5252;
  }
  .resPassword-div1 input{
      margin-bottom: 15px;
      height: 35px;
      width: 100%;
      border-radius: 15px;
      text-indent: 20px;
      border:0;

  }
  .resPassword-div1 button{
    margin-top: 20px;
    padding: 0 15px;
    height: 30px;
    background-color: unset;
    border: solid rgba(250, 250, 250, 1) 1px;
    border-radius: 20px;
    color:#FAFAFA;
    line-height: 29px;
  }
  .resPassword-div1 button:hover{
    transition: border-color 0.4s ease 0s, background-color 0.4s ease 0s;
    background-color: #fafafa;
    color:#333;
  }
  .resPassword-div1 p{
      font-size: 25px;
      font-family:jura;
      line-height: 30px;
      
  }
  .resPassword-div1 p:nth-child(3){
      margin-bottom: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/content/resPassword.vue